import React, { Component } from 'react';

class Leadership extends Component {
  render() {
    if (this.props.resumeLeadership && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.leadership;
      var items = this.props.resumeLeadership.map(function (item, i) {
        return (
          <div className='col-md-6 mb-4' key={i}>
            <div className='card leadership-card h-100'>
              <div className='card-body text-left'>
                <div className='leadership-head'>
                  <div>
                    <h4 className='leadership-role'>{item.role}</h4>
                    <h5 className='leadership-org'>
                      {item.organisation}
                      {item.years ? (
                        <span className='leadership-years'> &middot; {item.years}</span>
                      ) : null}
                    </h5>
                  </div>
                  {item.image ? (
                    <img className='leadership-logo' src={item.image} alt='' />
                  ) : null}
                </div>
                <p className='leadership-text font-trebuchet'>{item.description}</p>
                {item.url ? (
                  <a
                    className='leadership-link'
                    href={item.url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    {item.url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')} &rarr;
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <section id='leadership'>
        <div className='col-md-12'>
          <h1>
            <span>{sectionName}</span>
          </h1>
          <div className='col-md-10 mx-auto'>
            <div className='row'>{items}</div>
          </div>
        </div>
      </section>
    );
  }
}

export default Leadership;
